import { Box, Stack } from '@src/shared/ui/layout';
import TasksFilter from './TasksFilter';
import TasksHeader from './TasksHeader';
import TasksList from './TasksList';

const StyleSheet = {
  root: {
    height: '100%',
  },
  headerWrapper: {
    padding: '20px 20px 0 20px',
  },
};
export default function Tasks() {
  return (
    <Stack spacing={0.5} useFlexGap sx={StyleSheet.root}>
      <Box sx={StyleSheet.headerWrapper}>
        <TasksHeader />
        <TasksFilter />
      </Box>
      <TasksList />
    </Stack>
  );
}
